// [2026-08-11] ADDED — shadcn Table.
//
// The wrapper's `overflow-x-auto` is load-bearing, not styling: several tables in this product are
// wider than a laptop viewport, and without it the PAGE scrolls sideways instead of the table.
// A dashboard whose body scrolls horizontally feels broken on every screen, not just the wide one.
//
// `border-collapse` and cell padding are declared here because Tailwind's preflight — which would
// normally supply them — is deliberately not imported (src/shadcn.css).

import { cn } from '../../lib/utils.js'

function Table({ className, wrapperClassName, ...props }) {
  return (
    <div className={cn('w-full overflow-x-auto', wrapperClassName)}>
      <table
        className={cn('w-full caption-bottom border-collapse text-[13px]', className)}
        {...props}
      />
    </div>
  )
}

function TableHeader({ className, ...props }) {
  return <thead className={cn('[&_tr]:border-b [&_tr]:border-solid [&_tr]:border-border', className)} {...props} />
}

function TableBody({ className, ...props }) {
  return (
    <tbody
      className={cn('[&_tr:last-child]:border-0 [&_tr]:border-b [&_tr]:border-solid [&_tr]:border-border',
                    className)}
      {...props}
    />
  )
}

function TableRow({ className, interactive, ...props }) {
  return (
    <tr
      className={cn('transition-colors', interactive && 'cursor-pointer hover:bg-secondary',
                    className)}
      {...props}
    />
  )
}

function TableHead({ className, numeric, ...props }) {
  return (
    <th
      className={cn(
        'px-3 py-2.5 align-middle text-[11px] font-semibold uppercase tracking-wider',
        'text-muted-foreground', numeric ? 'text-right' : 'text-left', className,
      )}
      {...props}
    />
  )
}

function TableCell({ className, numeric, ...props }) {
  return (
    <td
      className={cn('px-3 py-2.5 align-middle', numeric && 'text-right tabular-nums', className)}
      {...props}
    />
  )
}

export { Table, TableBody, TableCell, TableHead, TableHeader, TableRow }
